var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.599 256c0-47.128 38.205-85.333 85.333-85.333 47.128 0 85.333 38.206 85.333 85.333 0 47.129-38.206 85.333-85.333 85.333-47.129 0-85.333-38.205-85.333-85.333z",
    fill: "#00bcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.932 426.667c0-47.128 38.205-85.333 85.333-85.333l45.475-24.009 39.858 24.009v85.333c0 47.129-38.205 85.333-85.333 85.333-47.128 0-85.333-38.205-85.333-85.333z",
    fill: "#00cf7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.599 0-46.434 80.67 46.434 89.996h84.136c47.129 0 85.333-38.205 85.333-85.333 0-47.128-38.205-85.333-85.333-85.333z",
    fill: "#ff7361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.734 85.333c0 47.128 38.205 85.333 85.333 85.333l45.267 17.484 41.263-17.484v-170.666h-86.531c-47.127 0-85.332 38.205-85.332 85.333z",
    fill: "#ff4d12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.932 256c0 47.129 38.205 85.333 85.333 85.333h85.333v-170.667h-85.333c-47.128 0-85.333 38.206-85.333 85.334z",
    fill: "#b659ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.a434eb74c5282c9a269092a9dd30bdf5.svg";
export { ForwardRef as ReactComponent };